































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {Role} from '@/enums/Role'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import AuditoriaMotivo from '@/model/resource/AuditoriaMotivo'

const metaInfo = () => ({
  title: $.t('view.manage.auditReasonList.title'),
})

@Component({
  metaInfo,
})
export default class ManageAuditReasonListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/role') role!: Role
  @Getter('auth/responsavel') user!: Responsavel

  Role = Role
  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(AuditoriaMotivo, {}, 10)

  created() {
    this.collection.endpoint = '/user/auditoria-motivo/responsavel'
  }
}
